
import { useCallback, useEffect, useState } from "react";
import './styles.scss';
import { MinusCircleIcon, PlusCircleIcon } from "@phosphor-icons/react";

const Stepper = ({ updateQuantity, cartItem }) => {
    const [value, setValue] = useState(cartItem.quantity);

    const updateValue = useCallback((type) => {
        if (type === "plus" && cartItem.product.stock <= value) {    
            setValue(cartItem.product.stock)
            return;
        } 
        if (type) {
            let x = value;

            if (type === "minus") {
                x--
            } else {
                x++
            }

            setValue(x >= 0 ? x : 0)
        }
    }, [value, cartItem.product.stock])

    useEffect(() => {
        if ((value || value === 0) && cartItem && cartItem.product) {
            updateQuantity(value, cartItem.product)
        }
    }, [value, updateQuantity, cartItem, cartItem.product])

    return (
        <div className="stepper-wrapper">
            <div className="stepper">
                <div onClick={() => updateValue("minus")}><MinusCircleIcon size={24} /></div>
                <p>{value}</p>
                <div onClick={() => updateValue("plus")}><PlusCircleIcon size={24} /></div>
            </div>
        </div>
    )
}

export default Stepper;